import { render, staticRenderFns } from "./sender_override.vue?vue&type=template&id=ee5445a8&"
import script from "./sender_override.vue?vue&type=script&lang=js&"
export * from "./sender_override.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports